import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ea27bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalPointHistory",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center w-100 fw-bold" }
const _hoisted_6 = { class: "modal-body content p-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-4 mt-4" }, null, -1))
const _hoisted_8 = { class: "mx-4" }
const _hoisted_9 = { class: "d-flex mx-4" }
const _hoisted_10 = { class: "d-flex align-items-center ms-3" }
const _hoisted_11 = { class: "table-responsive mx-4" }
const _hoisted_12 = { class: "table table-borderless" }
const _hoisted_13 = { class: "align-middle text-center" }
const _hoisted_14 = { class: "rounded-top" }
const _hoisted_15 = { class: "rounded-top" }
const _hoisted_16 = { id: "table-body" }
const _hoisted_17 = { class: "d-flex justify-content-center" }
const _hoisted_18 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_19 = { class: "d-flex mx-4" }
const _hoisted_20 = { class: "d-flex align-items-center ms-3" }
const _hoisted_21 = { class: "my-4 border-top pt-4 d-flex justify-content-center" }

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/button/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import PaginationModal from '@/components/pagination/paginationContractHistory.vue'
import TotalRecords from '@/components/total-records/index.vue'
import { translate } from '@/languages/i18n'
import { ACCOUNT_STORE, COMMUNITY_ALUMNUS_STORE } from '@/store/constants'
import { useRouter } from 'vue-router'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const pointHistory = computed(() => store.getters[ACCOUNT_STORE.GETTERS.POINT_HISTORY])
const curPage = ref(1)
const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DETAIL_ALMNUS]?.detailAlmnus)
const pageOfNumber = ref(30)

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const changeQuery = (query: any): void => {
  pageOfNumber.value = query?.page_of_number
  curPage.value = query?.page
  store.dispatch(ACCOUNT_STORE.ACTIONS.SET_POINT_HISTORY, {
    id: router.currentRoute.value.params?.id,
    userId: dataDetail.value?.alumni_user_id,
    params: {
      page: query?.page || 1,
      page_of_number: query?.page_of_number || 30,
    },
  })
}
const BackForm = () => {
  pageOfNumber.value = 30
  curPage.value = 1
  document.getElementById('table-body').scrollTop = 0
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE30pointHistory')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: BackForm
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(TotalRecords, {
              totalRecords: _unref(pointHistory)?.total_records
            }, null, 8, ["totalRecords"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(PaginationModal, {
                totalPage: _unref(pointHistory)?.total_pages || 1,
                onChangeQuery: changeQuery,
                isNotFilterUrl: true,
                pageOfNumber: pageOfNumber.value,
                curPage: curPage.value
              }, null, 8, ["totalPage", "pageOfNumber", "curPage"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number',
                onChangeQuery: changeQuery,
                isNotFilterUrl: true,
                pageOfNumber: pageOfNumber.value
              }, null, 8, ["options", "pageOfNumber"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_13, [
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_unref(translate)('OE30createAt')), 1),
                  _createElementVNode("th", _hoisted_15, _toDisplayString(_unref(translate)('OE30point')), 1)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pointHistory).data, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0 }]),
                    key: index
                  }, [
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(ConvertFromLocalTime)(item.created_at)), 1),
                    _createElementVNode("td", null, _toDisplayString(item?.points ? item?.points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0) + " pt", 1)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          (_unref(pointHistory)?.total_records === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(translate)('CC10noData')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createVNode(PaginationModal, {
                totalPage: _unref(pointHistory)?.total_pages || 1,
                onChangeQuery: changeQuery,
                isNotFilterUrl: true,
                pageOfNumber: pageOfNumber.value,
                curPage: curPage.value
              }, null, 8, ["totalPage", "pageOfNumber", "curPage"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number',
                onChangeQuery: changeQuery,
                isNotFilterUrl: true,
                pageOfNumber: pageOfNumber.value
              }, null, 8, ["options", "pageOfNumber"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              "data-bs-dismiss": "modal",
              type: 'secondary',
              onClick: BackForm
            }, null, 8, ["title"])
          ])
        ])
      ], 512), [
        [_directive_click_outside, BackForm]
      ])
    ])
  ]))
}
}

})